module.exports = __webpack_public_path__ + "img/chaudiere-individuelle.64bf1dc1.svg";